<template>
    <div class="myOrder">
        <!-- 头部 -->
        <headerTail></headerTail>
        <!-- 中间内容 -->
        <div class="containnnn">
            <div class="contain">
                <div class="containDiv"> 
                    <!-- 我的订单 -->
                    <p class="titletitle">我的订单</p>
                    <el-table v-loading="loadingtable" :data="tableDataPagination" @row-click="clickTable" ref="refTable" :row-key="getRowKeys" :expand-row-keys="expands" stripe style="width:100%">
                        <!-- 折叠部分的购票人信息 -->
                        <el-table-column type="expand" width="30" class="tablecolumn">
                            <template slot-scope="props">
                                <el-row>
                                    <el-col :span="24">
                                        <el-form label-position="left" inline class="demo-table-expand fromdivdiv">
                                            <el-form-item label="购票信息">
                                                <div class="people">
                                                    <ul>
                                                        <li>  
                                                            <el-row>
                                                                <el-col :span="10">
                                                                    <i class="holdername">{{props.row.tiketName}}</i>
                                                                </el-col>
                                                                <el-col :span="14">
                                                                    <i>{{props.row.ordertotal}}张</i>
                                                                </el-col>
                                                            </el-row>                                                                                                                                                     
                                                        </li>
                                                    </ul>
                                                </div>
                                            </el-form-item>
                                        </el-form>
                                    </el-col>
                                </el-row>                       
                            </template>
                        </el-table-column>
                        <el-table-column label="序号" type="index" width="50"></el-table-column>
                        <el-table-column label="订单编号" prop="id"></el-table-column>
                        <el-table-column label="入园日期" width="120">
                            <template slot-scope="scope">
                                <span>{{scope.row.bookdate.replace(/^(\d{4})(\d{2})(\d{2})$/,"$1-$2-$3")}}</span><br>
                            </template>
                        </el-table-column>
                        <el-table-column label="购票时间" width="120">
                            <template slot-scope="scope">
                                <!-- <span>{{scope.row.ordertime.slice(0,10)}}<br>{{scope.row.ordertime.slice(-8)}}</span> -->
                                <span>{{scope.row.ordertime.slice(0,10)}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="购票数量" prop="ordertotal" width="80px"></el-table-column>
                        <!-- <el-table-column label="手机号码" prop="mobileno" width="145"></el-table-column> -->
                        <el-table-column label="订单确认码" width="170px">
                            <template slot-scope="scope">
                                <span v-if="scope.row.code">{{scope.row.code}}</span>
                                <span v-else> — </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="订单状态" width="110px">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status==0">待支付</span>
                                <span v-if="scope.row.status==2">退款中</span>
                                <span v-if="scope.row.status==3">已退款</span>
                                <span v-if="scope.row.status==4">订单失效</span>
                                <span v-if="scope.row.status==5">已使用</span>
                                <span v-if="scope.row.status==6">已过期</span>
                                <span v-if="scope.row.status==1 && scope.row.ticket_status==0">未出票</span>
                                <span v-if="scope.row.status==1 && scope.row.ticket_status==1">已出票</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="总计" width="100px">
                            <template slot-scope="scope">
                                <span class="redSpan">{{scope.row.orderamout}} 元</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="125px">
                            <template slot-scope="scope">
                                <!-- 
                                    status为0,未付款；status为1,已付款；status为2,退款中；status为3,已退款；status为4,订单失效；
                                    ticket_status为0，未出票；ticket_status为1，已出票；
                                    booktimestatus为null，没有改签过；booktimestatus为1，已经改签过 
                                    invoicestatus为false，没有开票；为true，已开过票
                                -->
                                <!-- 当status=0时，操作为：待支付、删除 -->
                                <div v-if="scope.row.status==0">
                                    <el-button size="mini" :disabled='btnState' @click="handlePay(scope.$index, scope.row)" class="firstBtn">待支付</el-button><br>
                                    <el-button size="mini" @click.native.prevent="handleDelete(scope.$index, scope.row)">删除</el-button>
                                </div>
                                <!-- 当status=1，并且已出票，并且没有改签过(booktimestatus为null)时，操作为：改签 -->
                                <!-- <div v-if="scope.row.status==1 && scope.row.ticket_status==1 && scope.row.booktimestatus==null">                                   
                                    <el-button size="mini" @click="handleChange(scope.$index, scope.row)" class="firstBtn">改签</el-button>
                                </div> -->
                                <!-- 当status=1，并且已出票时，操作为：退票 -->
                                <div v-if="scope.row.status==1 && scope.row.ticket_status==1">   
                                    <el-button size="mini" @click.native.prevent="sendCode(scope.$index, scope.row)" class="firstBtn">查看票码</el-button>
                                    <el-button size="mini" @click="handleRefund(scope.$index, scope.row)">退票</el-button>
                                </div>
                                <!-- 当status=1，并且未出票时 -->
                                <div v-if="scope.row.status==1 && scope.row.ticket_status==0"> — </div>
                                <!-- 当status为2或3，退款中或已退款时 -->
                                <div v-if="scope.row.status==2 || scope.row.status==3 "> — </div>
                                <!-- 当status为4，删除 -->
                                <div v-if="scope.row.status==4">
                                    <el-button size="mini" @click.native.prevent="handleDelete(scope.$index, scope.row)">删除</el-button>
                                </div>
                                <!-- 当status为5或6，可查看票码 -->
                                <div v-if="scope.row.status==5 || scope.row.status==6">
                                    <el-button size="mini" @click.native.prevent="sendCode(scope.$index, scope.row)">查看票码</el-button>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <!-- 分页 -->
                    <div v-if="total">
                        <el-pagination background layout="prev, pager, next" :total=parseInt(total) @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pagesize">
                        </el-pagination>
                    </div>
                </div> 
                <!-- 页尾 -->
                <div class="footerDiv">
                    <div class="left">
                        <span>热线电话：0874-6881555</span>
                        <span style="margin-right:0;">开放时间：08:30-18:30</span>
                        <br>
                        <span>景区地址：云南省曲靖市陆良县城西南20公里</span>
                        <span style="margin-right:0;">邮政编码：655699</span>
                        <br>
                        <span>版权所有：@2018 All Rights Rserved 云南曲靖陆良彩色沙林智慧景区</span>
                    </div>
                    <div class="right">
                        <div style="margin-left:10px">
                            <img src="@/assets/images/wx.jpg" alt="">
                            <p>官网微信</p>
                        </div>
                        <!-- <div>
                            <img src="@/assets/images/wx.jpg" alt="">
                            <p>官方微博</p>
                        </div> -->
                    </div>
                </div>              
            </div>
        </div>
        <!-- 页尾 -->
        <!-- <footerTail></footerTail> -->

        <!-- 弹出层 - 选择支付方式 -->
        <div class="refundtype">   
            <el-dialog :visible.sync="dialogType" :close-on-press-escape=false :close-on-click-modal=false width="680px">              
                <div class="typediv">
                    <el-row>
                        <el-col :span="9">
                            <div class="lefttt">
                                <p class="piaozhong">票 种：{{orderRow.tiketName}}</p>
                                <p v-if="orderRow">
                                    入园日期：
                                    <span>{{orderRow.bookdate.replace(/^(\d{4})(\d{2})(\d{2})$/,"$1-$2-$3")}}</span>
                                </p>
                                <p>购买数量：{{orderRow.ordertotal}}</p>
                            </div>
                        </el-col>
                        <el-col :span="15">
                            <div class="righttt">
                                <p>支付方式：</p>
                                <div class="radioimg">
                                    <el-radio v-model="radio" label="0">
                                        <img src="@/assets/images/payzhi.png" alt="">
                                    </el-radio>
                                    <el-radio v-model="radio" label="1">
                                        <img src="@/assets/images/paywei.png" alt="">
                                    </el-radio>
                                </div>
                                <p class="jine">应付金额：<i>{{orderRow.orderamout}}</i>元</p>
                                <el-button  class="sumbtn" @click="quesumit">确认支付</el-button>
                                <el-button @click="fansumit">返 回</el-button>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </el-dialog>
        </div> 

        <!-- 弹出层 - 二维码 -->
        <div class="canvasDiv">
            <el-dialog :visible.sync="dialogVisible" @opened="dialogOpend1" :close-on-press-escape=false :close-on-click-modal=false :show-close=false width="470px">
                <div class="canvasxinxi">
                    <p>票 种：{{orderRow.tiketName}}</p>
                    <p>订单编号：{{orderRow.id}}</p>
                    <p v-if="orderRow">
                        入园日期：
                        <span>{{orderRow.bookdate.replace(/^(\d{4})(\d{2})(\d{2})$/,"$1-$2-$3")}}</span>
                    </p>
                    <p>付款金额：<i>{{orderRow.orderamout}}元</i>
                    </p>
                </div>
                <div class="DivDiv">
                    <div v-if="dialogVisible" id="qrcode1" ref="qrcode1"></div>
                    <p>请使用微信，扫一扫图片上的二维码</p>        
                    <i style="line-height:1.6;">提示：订单有效期30分钟，支付完成前请不要关闭此弹窗</i>   
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="clickCanvas1">关 闭</el-button>
                </span>
            </el-dialog>
        </div>

        <!-- 弹出层 - 查看票码 -->
        <div class="canvasDiv">
            <el-dialog :visible.sync="dialogVisibleCode" @opened="dialogOpend2" :close-on-press-escape=false :close-on-click-modal=false :show-close=false width="470px">
                <div class="canvasxinxi">
                    <p>订单编号：{{orderRow.id}}</p>
                    <p v-if="orderRow">
                        入园日期：<span>{{orderRow.bookdate.replace(/^(\d{4})(\d{2})(\d{2})$/,"$1-$2-$3")}}</span>
                    </p>
                </div>
                <div class="DivDiv">
                    <div v-if="dialogVisibleCode" id="qrcode2" ref="qrcode2"></div>                  
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="clickCanvas2">关 闭</el-button>
                </span>
            </el-dialog>
        </div>

        <!-- 弹出层 - 退票 -->
        <div class="refundDiv"> 
            <el-dialog title="退票申请" :show-close=false :close-on-press-escape=false :close-on-click-modal=false :visible.sync="dialogDiv" width="450px">
                <div>
                    <p><i class="el-icon-question"></i>您确定要退票吗？</p>
                    <ul>
                        <li>订单编号：<i>{{orderRow.id}}</i></li>
                        <li>共计退款：
                            <i>{{orderRow.orderamout}}元</i>
                        </li>
                    </ul>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogDiv = false" v-show="btnshow">取消</el-button>
                    <el-button type="primary" :loading="btnloading" @click="clickRefundDiv">确定</el-button>
                </span>
            </el-dialog>
        </div> 
               
    </div>
</template>

<script>
import headerTail from "@/components/common/headerTail.vue";
import footerTail from "@/components/common/footerTail.vue";
import api from "@/api/myOrder.js";
import store from "@/vuex/store";
import router from '../router';
import QRCode from 'qrcodejs2'
let Base64 = require('js-base64').Base64;
export default {
  name: "myOrder",
  data() {    
    return {
      pagesize: 10,
      currentPage: 1,
      total: "",              // 分页时的总条数
      getRowKeys(row) {       // 获取row的key值        
        return row.id;
      },
      expands: [],            // 要展开的行，数值的元素是row的key值
      orderid: "",            // 订单id
      tableData: [],          // 订单列表
      orderData: [],          // 订单详情
      payUrl: "",             // 二维码地址
      dialogVisible: false,
      dialogDiv: false,
      dialogEInvoice: false,
      orderRow: "",           // 接收点击行的整行信息
      timer:'',                // 接收定时器
      loadingtable: false,
      btnloading: false,
      btnshow: true,
      tableDataPagination: [],
      btnState: false,    // 付款按钮状态
      url: '',           // 付款二维码
      codeurl: '',     // 查看票码-二维码
      dialogVisibleCode: false,
      dialogType: false,
      radio: ''
    };
  },
  store,
  components: {
    headerTail,
    footerTail,
    QRCode
  },
  created() {      
    this.orderLists();          
  },
  methods: {
    // 展开第一条
    firstOrder() {
        if(this.tableData.length!=0){
            // 查询第一条订单的订单详情
            api.orderDetail(this.tableDataPagination[0].id).then(Response => {
                // //console.log(Response);
                this.$set(this.tableDataPagination[0], 'detailList', Response.data.detailList)
                this.expands.push(this.tableDataPagination[0].id);  // 展开第一条
            })
            .catch(error => {
                //console.log(error);
            });
        }     
    },
    // 点击行展开
    clickTable(row, column, event) {
        api.orderDetail(row.id).then(Response => {
            //   //console.log(Response);
            this.$set(this.tableDataPagination[row.num], 'detailList', Response.data.detailList)
            this.$refs.refTable.toggleRowExpansion(row);    // 点击行展开
        })
        .catch(error => {
            //console.log(error);
        });
    },
    // 订单列表
    orderLists() {
      this.loadingtable = true;
      api.orderList({}).then(Response => {
          //console.log(Response);        
          this.tableData = Response.data;
          this.total = Response.data.length;
          this.tableDataPagination = this.tableData.slice((this.currentPage-1)*this.pagesize,this.currentPage*this.pagesize);        
          this.firstOrder();
          this.tableDataPagination.forEach((elem,i) => {
              this.tableDataPagination[i].num=i;
              this.tableDataPagination[i].detailList=[];
          });
          this.loadingtable = false;
        })
        .catch(error => {
          //console.log(error);
          this.loadingtable = false;
        });
    },
    quesumit(){
        if(this.radio==''){
            this.$message.error('请选择支付方式'); 
            return false
        } 
        if(this.radio=='0'){   // 支付宝支付   *************** 记得改url **************
            window.location.href = 'http://ticket.csshl.com:20030/ali/payInfoPc?orderId='+this.orderRow.id+'&url=http://ticket.csshl.com:20030/ticketPC/#/myOrder';
            // window.location.href = 'http://10.201.8.26/ali/payInfoPc?orderId='+this.orderRow.id+'&url=http://192.168.0.126:26782/#/myOrder';
            this.btnState = false;
            this.dialogType = false; 
        }
        if(this.radio=='1'){   // 微信支付
            this.dialogType = false;
            this.url = "" 
            this.orderid = this.orderRow.id;
            api.getPrepayId(this.orderRow.id).then(res=>{
                this.btnState = false; 
                if(res.data){              
                    this.url = res.data.code_url;
                    this.dialogVisible=true; 
                    // 每隔3S请求一次订单详情接口，直到状态为已付款status==1
                    this.timer = setInterval(() => {
                        this.orderDetails();      //根据id查询订单详情
                        if(this.orderData.status == 1) {
                            clearInterval(this.timer);
                            this.timer = "";
                            this.dialogVisible = false;
                            this.orderLists();    // 订单列表
                            this.$message.success('订单付款成功');  
                        }else if(this.orderData.status == 4){
                            clearInterval(this.timer);
                            this.timer = "";
                            this.dialogVisible = false;
                            this.orderLists();    // 订单列表
                            // this.$message.error('订单已失效');   
                        }
                    }, 3000);
                }
            }).catch(error=>{
                console.log(error)
                this.btnState=false;
                this.dialogVisible = false;
                this.orderLists();    // 订单列表
            })
        }
    },
    fansumit(){
        this.btnState = false;
        this.orderLists();    // 订单列表
        this.dialogType = false;
    },
    // 点击待支付按钮
    handlePay(index, row) {
        this.orderRow = row;
        this.btnState=true;  
        this.dialogType = true;  
    },
    // 二维码-打开弹出层且动画结束后触发
    dialogOpend1(){         
        let qrcode = new QRCode('qrcode1', {  
			width: 150,     // 二维码宽度 
			height: 150,    // 二维码高度
			text: this.url
        })       
    },
    dialogOpend2(){         
        let qrcode = new QRCode('qrcode2', {  
			width: 150,     // 二维码宽度 
			height: 150,    // 二维码高度
			text: this.codeurl
        })       
    },
    // 点击二维码弹框的关闭按钮
    clickCanvas1(show) {
      clearInterval(this.timer);    //当点击关闭按钮时，停止定时器
      this.timer = "";
      this.orderLists();
      this.dialogVisible = false;
    },
    clickCanvas2(show) {
      clearInterval(this.timer);    //当点击关闭按钮时，停止定时器
      this.timer = "";
      this.orderLists();
      this.dialogVisibleCode = false;
    },
    // 查看票码
    sendCode(index, row){
        this.orderRow = row;
        this.codeurl = row.code; 
        this.dialogVisibleCode=true;
    },
    // 删除按钮
    handleDelete(index, row) {
        this.orderid = row.id;
        api.orderDetail(row.id).then(Response => {   //点击删除时，根据id查询订单详情的状态：待支付、订单失效
            if(Response.data.status == 0 || Response.data.status == 4){           
                // 提示：确定要删除此订单吗？  
                this.$confirm('确定要删除此订单吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: "warning"
                })
                .then(() => {
                    api.cancelOrder(row.id).then(Response => {
                        //console.log(Response);
                        this.$message.success('订单删除成功');
                        this.tableData.splice(index, 1);
                        this.orderLists();     // 订单列表
                    })
                    .catch(error => {
                        //console.log(error);
                    });
                })
                .catch(() => {
                    //console.log("客户已取消删除");
                });
            }else{
                this.orderLists();     // 订单列表
            } 
        })
        .catch(error => {
            //console.log(error);           
        });  
    },
    // 退票按钮
    handleRefund(index, row) {
      //console.log(index, row);
      this.orderRow=row;
      this.orderid = row.id;
      api.orderDetail(row.id).then(Response => {   //点击退票时，根据id查询订单详情的状态：已支付&&已出票
            if(Response.data.status == 1 && Response.data.ticket_status==1){           
                this.dialogDiv=true;
            }else{
                this.orderLists();     // 订单列表
            } 
        })
        .catch(error => {
            //console.log(error);           
        });
    },
    //点击退票的确定按钮后，调后台接口
    clickRefundDiv(){
        this.btnloading = true;
        this.btnshow = false;
        api.refundOrder(this.orderid).then(Response => {
            //console.log(Response);
            this.$message.success('申请退款成功');
            this.dialogDiv=false;
            this.btnloading = false;
            this.btnshow = true;
            setTimeout(() => {                    
                this.orderLists();
            }, 1000);
        })
        .catch(error => {
            //console.log(error);
            this.btnshow = true;
            this.btnloading = true;
        });
    },
    // 分页 - 每页条数pageSize改变时会触发
    handleSizeChange(val) {
      this.pagesize = val;
    
    },
    // 分页 -  当前页currentPage改变时会触发
    handleCurrentChange(val) {
      this.currentPage = val;
        this.orderLists();  
    },
    // 根据id查询订单详情
    async orderDetails() {
        let Response=await api.orderDetail(this.orderid)
        this.orderData = Response.data;
    }   
  },
  //组件销毁前调用
  beforeDestroy() {
    if(this.timer) {               //如果定时器还在运行，直接关闭
        clearInterval(this.timer); 
        this.timer = "";
    }   
  },
  
  
};
</script>

<style lang="stylus" scoped>
#canvas {
    width: 200px !important;
    height: 200px !important;
}
.containnnn{
    background: url(/static/img/bg.8a8796e.jpg) no-repeat center;
    background-size: cover;
}
.contain {
    // height: 1308px;
    .containDiv {
        padding: 90px 32px;
        width: 1136px;
        background-color: #fff;

        .titletitle {
            margin: 0 0 48px 40px;
            font-weight: bold;
        }

        .el-table {
            .el-button {
                padding: 7px 13px;
                background-color: #16365c;
                border: none;
                color: #fff;
                border-radius: 5px;
                width: 74px;
            }

            .firstBtn {
                margin-bottom: 10px;
            }

            .redSpan {
                color: #db191d;
            }
        }

        .el-pagination {
            text-align: right;
            margin-top: 40px;
        }

        .demo-table-expand {
            .people {
                padding: 0;
                width: 791px;

                ul li {
                    color: #606266;
                    margin-bottom: 3px;
                    // display: flex;

                    .idtypeDiv {
                        padding: 0;
                        display: inline-block;
                        text-align: center;
                        width: 100%;
                    }

                    .holdername {
                        padding: 0;
                        width: 100%;
                        display: inline-block;
                        text-align: center;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                    .el-col{
                        height: 40px;
                        line-height: 40px;
                    }
                }
            }
        }

        .demo-table-expand .el-form-item {
            margin-right: 0;
            margin-bottom: 0;
            width: 100%;
        }
        .el-row{
            display: flex;
            // align-items: stretch;
        }
    }
}
.eInvoicessss{
    text-align: center;
    height: 40px;
    line-height: 40px;
    .eInvoice{
        color: #3182d6;
        cursor: pointer;
    }
} 
.canvasDiv {
    .DivDiv {
        text-align: center;
        p {
            padding: 10px 0 5px 0;
            line-height: 1.6;
        }
        span{
           color: #db191d;
           display: block; 
           padding: 5px 0;
        }
        
    }

    .canvasxinxi{
        p{
            padding: 0 0 10px 20px;
            i{
                color: #db191d;
                margin-left: 5px;
            }
        }

    }
}
.refundDiv{
    p{
        font-size: 16px;
        height: 30px;
        line-height: 30px;
        .el-icon-question{
            font-size: 30px;
            color: #E6A23C;
            float: left;
            padding-right: 12px;
        }
    }
    ul{
        margin: 20px 0 40px 0;
        border-top: 1px dotted #ebebeb;
        border-bottom: 1px dotted #ebebeb;
        padding: 20px 15px 0 15px;
        li{
            margin-bottom: 20px;
            i{
                color: #E6A23C;
                padding-left: 5px;
            }
        }
    }
    .el-button{
        padding: 9px 20px;
        border-radius: 8px;
    }
    .el-button--primary{
        background-color: #16365c;
        border: solid 1px #16365c;       
    }
    
} 
.refundtype{
    .typediv{
        background-color: #f2f2f2;
        .lefttt{
            padding: 40px 10px 10px 30px;
            p{
                padding-bottom: 10px;
            }
        } 
        .righttt{
            background-color: #fff;
            padding: 40px 10px 130px 30px;
            p{
                padding-bottom: 12px;
            }
            img{
                height: 38px;
            }
        }
        .piaozhong{
            font-size: 16px;
            font-weight: bold; 
            padding-bottom: 20px!important;
        }
        .jine{
            padding: 50px 0 !important;
            i{
                padding: 0px 3px 0 6px;
                font-weight: bold;
                font-size: 18px;
                color: #db191d;
            } 
        }
        .sumbtn{
            color: #fff;
            background-color: #ED6045;
            border: none;
            font-size: 16px;
            border-radius: 5px;
            letter-spacing: 1px;
        }
    } 
} 


//页尾
.footerDiv{
        position: relative;
        z-index: 2;
        box-sizing: border-box;
        border-top: 1px solid #987943;
        color: #333;
        width: 100%;
        height: 280px;
        margin: 0 auto;
        margin-top: 40px;
        font-size: 14px;
        .left{
            float: left;
            padding-top: 74px;
            span{
                margin: 0 14px 25px 0;
                display: inline-block;
            }
        }
        .right{
            float: right;
            padding-top: 53px;
            text-align: center;
            >div{
                float: left;
                margin-left: 34px;
                >img{
                    width: 136px;
                }
            }
            p{
                margin-top: 10px;
            }
        }
}


</style>
<style>
.myOrder table th >.cell {
  text-align: center;
  color: #333;
  padding: 5px 0;
}
.myOrder table td > .cell {
  text-align: center;
  color: #666;
  padding: 5px 0;
}
.el-pagination.is-background .el-pager li:not(.disabled):hover {
  color: #16365c!important;
}
.myOrder .el-pagination .el-pager li:not(.disabled).active {
  background-color: #16365c!important;
  color: #fff!important;
}
.myOrder .demo-table-expand label {
  color: #99a9bf;
}
.myOrder .canvasDiv .el-dialog__footer {
  text-align: center;
}
.myOrder .refundDiv .el-dialog__body {
    padding: 10px 40px;
}
.myOrder .refundDiv .el-dialog__title{
    font-size: 16px;
}
.myOrder .eInvoiceDiv .el-form-item__label{
    width: 147px!important;
}
.myOrder .eInvoiceDiv .pdiv{
    color: #eb1414;
    font-size: 14px;
    line-height: 2;
    margin: 0 0 0 64px;
}
.myOrder .eInvoiceDiv .ulul{
    margin: 0 0 22px 64px;
    color: #eb1414;
    font-size: 14px;
    line-height: 2;
    list-style: disc;
}
.myOrder .eInvoiceDiv .el-dialog__footer{
    text-align: center;
}
.myOrder .eInvoiceDiv .el-button{
    padding: 9px 20px;
    border-radius: 8px;
}
/* .myOrder .eInvoiceDiv .el-dialog__body{ */
    /* padding: 15px 20px; */
/* } */
.myOrder .eInvoiceDiv .el-button--primary{
    background-color: #16365c;
    border: solid 1px #16365c;
}
.myOrder .eInvoiceDiv .el-form-item__content{
    margin-left: 150px!important;
}
.myOrder .el-message-box__wrapper .el-message-box .el-button--primary{
    background-color: #16365c!important;
    border: solid 1px #16365c!important;
} 
.myOrder .fromdivdiv .el-form-item__content{
    line-height: 21px;
}
.myOrder .el-form-item {
    margin-bottom: 34px;
}
.myOrder .otherFormItem .el-form-item__label{
    line-height:20px
}
.containDiv .el-table .el-table__expanded-cell{
    padding: 20px 20px;
}
.containDiv .el-table__expand-icon {
    pointer-events: none!important;
}
.myOrder .canvasDiv #qrcode1,
.myOrder .canvasDiv #qrcode2{
    width: 150px!important;
    height: 150px!important;
    display: inline-block!important;
}
.myOrder .containDiv .el-button+.el-button {
    margin-left: 0!important;
}
.myOrder .refundtype .el-dialog__body,
.myOrder .refundtype .el-dialog__header{
    padding: 0!important;
}
.myOrder .refundtype .el-col{
    height: 100%;
}
.myOrder .refundtype .el-radio,
.myOrder .refundtype .el-radio__input{
    height: 40px!important;
}
</style>





// WEBPACK FOOTER //
// src/views/MyOrder.vue